<template>
  <v-app class="app-wrapper">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  data: () => ({
    //
  }),
}
</script>

<style lang="sass">
html, body
  height: 100%
  margin: 0
  padding: 0

.app-wrapper
  display: flex
  flex-direction: column
  min-height: 100vh

.main-content
  flex: 1

.accent
  color: #fc7b23
  &-bg
    background-color: #fc7b23 !important
</style>
